import { render, staticRenderFns } from "./EditCustomerButton.vue?vue&type=template&id=4bd33ea6"
import script from "./EditCustomerButton.vue?vue&type=script&lang=js"
export * from "./EditCustomerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports